import {useCallback, useEffect, useMemo, useState} from "preact/hooks";

const useRequest = (services, options = {}) => {
  const fetch = useMemo(() =>  new Fetch({services, options}),[])
  const [requestState,setRequestState] = useState(fetch.state);
  const run = useCallback((params) => {fetch.run(params).finally()}, [])
  useEffect(() => {
    fetch.changState = setRequestState;
  }, [setRequestState])
  useEffect(() => {
    if(!fetch.options.manual){
      run(fetch.options.params);
    }
  }, [run]);
  return {...requestState,run};
}
class Fetch {

  constructor({services, options  =  {}} = {}) {
    this.services = services;
    /**
     *
     * @type {{manual:boolean, params: any}}
     */
    this.options = options
  }

  options;

  changState;

  /**
   * @type {Function}
   */
  services;

  state = {
    loading : true,
    data: null,
    error: null
  }

  /**
   *
   * @param status {boolean}
   */
  changeLoading(status){
    this.state.loading = status;
  }

  changeResult(data,error){
    this.state.data = data;
    this.state.error = error;
  }


  run = async (params) => {
    try{
      this.changeLoading(true);
      this.changeResult(null, null);
      this.changState({...this.state});
      const result = await this.services(params);
      this.changeLoading(false);
      this.changeResult(result, null);
      this.changState({...this.state})
    }catch (e){
      this.changeLoading(false);
      this.changeResult(null,e);
      this.changState({...this.state});
    }
  }

}

export default useRequest;
